/**
 * Module de gestion des dialogues avec backdrop personnalisé.
 * Les dialogues utilisent `.show()` au lieu de `.showModal()` pour permettre
 * aux notifications et au loader de passer au-dessus.
 */

/**
 * Affiche le backdrop personnalisé pour les dialogues.
 */
function showBackdrop() {
    let backdrop = document.getElementById('dialog-backdrop');
    if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.id = 'dialog-backdrop';
        backdrop.className = 'dialog-backdrop';
        document.body.appendChild(backdrop);
    }
    backdrop.classList.remove('is-hidden');
}

/**
 * Cache le backdrop personnalisé.
 */
function hideBackdrop() {
    const backdrop = document.getElementById('dialog-backdrop');
    if (backdrop) {
        backdrop.classList.add('is-hidden');
    }
}

/**
 * Ouvre un dialogue avec backdrop personnalisé.
 * @param {string} dialogId - L'ID du dialogue
 */
export function openDialog(dialogId) {
    const dialog = document.getElementById(dialogId);
    if (dialog && !dialog.open) {
        showBackdrop();
        dialog.show();
    }
}

/**
 * Ferme un dialogue et son backdrop.
 * @param {string} dialogId - L'ID du dialogue
 */
export function closeDialog(dialogId) {
    const dialog = document.getElementById(dialogId);
    if (dialog && dialog.open) {
        dialog.close();
        hideBackdrop();
    }
}
